import Input from "../FormComponents/Input";

const EditSection = ({ editElementData, setEditElementData }) => {
  const handleSectionDataChange = (e) => {
    let value = e.target.value;
    switch (e.target.name) {
      case "collapse":
        value = e.target.checked;
        break;
      case "height":
        value = e.target.value * 1;
        break;
      default:
        break;
    }
    setEditElementData({ ...editElementData, [e.target.name]: value });
  };

  // const handleSectionClassName = (heading, selectedValue) => {
  //   setEditElementData({ ...editElementData, className: { ...editElementData.className, [heading]: selectedValue } });
  // };
  // const handleSectionStyle = (obj) => {
  //   setEditElementData({ ...editElementData, inline_style: { ...editElementData.inline_style, ...obj } });
  // };
  // const handleCustomCss = (e) => {
  //   const { name, value } = e.target;
  //   setEditElementData({ ...editElementData, [name]: value });
  // };
  return (
    <>
      <div className="field_horizontal_container">
        <Input
          label="Display"
          name="display"
          value={editElementData.display}
          onChange={handleSectionDataChange}
          containerClassName={"w_75"}
        />
        <Input
          type="number"
          label="Height"
          name="height"
          value={editElementData.height}
          onChange={handleSectionDataChange}
          containerClassName={"w_25"}
        />
      </div>
      <Input
        type="checkbox"
        label="Collapsible section"
        name="collapse"
        checked={editElementData.collapse}
        onChange={handleSectionDataChange}
      />
    </>
  );
};
export default EditSection;
